import ToggleButtonGroupMUI from '@mui/material/ToggleButtonGroup';
import React from 'react';
/**
 * Toggle buttons can be used to group related options.
 * More information: https://mui.com/components/toggle-button/
 */
export function ToggleButtonGroup(props) {
    return React.createElement(ToggleButtonGroupMUI, Object.assign({}, props));
}
